"use client"

import type { ReactNode } from "react"

import TrackInteractionProvider from "@blueshift-ui/telemetry/dist/components/track-interaction-provider"

type TelemetryProviderProps = {
  children: ReactNode
}

export default function TelemetryProvider({
  children
}: TelemetryProviderProps) {
  const applicationId = "practice-hub"

  const trackerEnv =
    process.env.NEXT_PUBLIC_INTERACTION_TRACKER_ENV ?? "production"
  const disabled = trackerEnv === "development"
  const preview = trackerEnv !== "production"

  return (
    <TrackInteractionProvider
      applicationId={applicationId}
      disabled={disabled}
      preview={preview}
      segmentWriteKey={process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}
    >
      {children}
    </TrackInteractionProvider>
  )
}
